/**
 * Transaction Header Status constants
 * These represent the various states a transaction can be in
 */
export const TRANSACTION_STATUS = {
  NEW: 1,
  DRAFT: 2,
  PENDING_REVIEW: 3,
  ACTIVE: 4,
  DELETED: 5,
  REVERSED: 6
} as const

export type TransactionStatusId = typeof TRANSACTION_STATUS[keyof typeof TRANSACTION_STATUS]

